import { Children, ReactNode } from 'react';
import { AnimatePresence } from 'motion/react';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useStackedCardWizardContext } from './stacked-card-wizard-context';
import { StepCard } from './step-card';
import { StepIndexProvider } from './step-index-context';

export const WizardRenderer = ({ children }: { children: ReactNode }) => {
  const { currentStep } = useStackedCardWizardContext();
  // Filter out falsy children (like conditional renders that evaluate to false)
  const actualChildren = Children.toArray(children).filter(Boolean);
  const visibleSteps = actualChildren.slice(currentStep);
  const isSmall = useMatchMedia({ maxWidth: breakpoints.small.min });
  const isMedium = useMatchMedia({ maxWidth: breakpoints.medium.min });
  const width = isSmall ? 300 : isMedium ? 500 : 800;

  return (
    <div
      css={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width,
        height: 360,
      }}
    >
      <AnimatePresence>
        {visibleSteps.map((step, stackIndex) => {
          const isActiveCard = stackIndex === 0;
          const stepKey = `step-${currentStep + stackIndex}`;
          const actualStepIndex = currentStep + stackIndex;

          return (
            <StepCard key={stepKey} isActive={isActiveCard} stackIndex={stackIndex}>
              <StepIndexProvider index={actualStepIndex}>{step}</StepIndexProvider>
            </StepCard>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
